import React, { FC } from "react";
import { useGetFileQuery } from "~/schemas/generated/graphql";
import { get } from "lodash";
import s from "./ProofDocumentControl.less";
import Preloader from "~/components/Preloader";
import IconTrash from "~/components/Icons/icon-trash";
import IconDownload from "~/components/Icons/icon-download";
import IconUpdate from "~/components/Icons/icon-update";
import { useSetLocationData } from "~/hooks/locationData";
import clsx from "clsx";
import { DownloadIcon } from '@pd/pd-ui-kit';

interface IProps {
  id: string;
  filesId?: string[];
  isPlanReport?: boolean;
  isOnlyDelet?: boolean;
  setFilesId?;
  isFileRow?: boolean;
}

const ProofDocumentControl: FC<IProps> = ({
  id,
  filesId,
  setFilesId,
  isPlanReport = false,
  isOnlyDelet = false,
  isFileRow = false,
}) => {
  const setData = useSetLocationData();
  const { data, loading, refetch } = useGetFileQuery({
    variables: {
      id,
    },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
  });

  const clearFile = () => {
    !filesId
      ? setData("fileId", "")
      : setFilesId(filesId.filter((e) => e !== id));
  };

  const fileData = get(data, "FileGetter.getFile");

  return loading ? (
    <Preloader />
  ) : (
    <div
      className={clsx(s.wrapper, {
        [s.wrapperPlan]: isPlanReport,
        [s.wrapperNew]: isOnlyDelet,
        [s.isFileRow]: isFileRow,
      })}
    >
      <div
        className={clsx(s.filePreview, {
          [s.filePreviewPlan]: isPlanReport,
          [s.isFileRowTitle]: isFileRow,
        })}
      >
        {fileData && fileData.name}
      </div>
      <div
        className={clsx(s.fileControls, {
          [s.fileControlsPlan]: isPlanReport,
          [s.fileControlsNew]: isOnlyDelet,
        })}
      >
        <button
          onClick={() => refetch()}
          className={clsx(s.customBtn, {
            [s.isOnlyDelet]: isOnlyDelet,
          })}
        >
          <IconUpdate />
        </button>
        <a
          href={fileData && fileData.link}
          download
          className={clsx(s.customBtn, s.download, {
            [s.isOnlyDelet]: isOnlyDelet,
          })}
        >
          <DownloadIcon />
        </a>
        <button onClick={clearFile} className={s.customBtn}>
          <IconTrash />
        </button>
      </div>
    </div>
  );
};

export default ProofDocumentControl;
